import { render, staticRenderFns } from "./CourseInfon.vue?vue&type=template&id=6f9c5856&"
import script from "./CourseInfon.vue?vue&type=script&lang=js&"
export * from "./CourseInfon.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports